export default "__VITE_ASSET__DAiw_nzL__"